//import material-UI

import {useForm, SubmitHandler, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";

import {
  checkListCloseAction,
  checkListSwitchAction,
  fieldCheckSearchListOpenAction,
  toastPopupOpenAction,
} from "../../features/sliceReducer/interactionReducer";
import {makeStyles, createStyles, withStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
  Select,
  MenuItem,
  Checkbox,
} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../features/store";
import {
  altFieldCheckImproveAction,
  getCheckList,
  getFieldCheck,
  updateFieldCheck,
} from "../../features/sliceReducer/myProjectReducer";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import ListIcon from "@material-ui/icons/List";
import BackupIcon from "@material-ui/icons/Backup";
import FileCopyIcon from "@material-ui/icons/FileCopy";

import {useEffect, useState} from "react";
import IPUtility from "../../classes/IPUtility";
import {IPFieldCheck} from "../../models/IPFieldCheck";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) => createStyles({}))(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "relative",
      width: "1480px",
      height: "860px",
      paddingBottom: "20px",
      backgroundColor: theme.palette.background.paper,
      border: `2px solid #4f5470`,
      boxShadow: theme.shadows[5],
    },

    table: {
      marginTop: "72px",
      border: "1px solid #9e9e9e",
      "& td": {
        padding: "10px",
        border: "1px solid #9e9e9e",
      },
    },
    buttonCell: {
      display: "flex",
      justifyContent: "space-around",
      border: "1px solid #dbdce0",
    },
    modalTitle: {
      position: "fixed",
      width: "1480px",
      padding: "12px 16px",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "bold",
      backgroundColor: "#4f5470",
      color: "white",
      zIndex: 100,
      "& h5": {
        display: "flex",
        alignItems: "center",
        "& svg": {
          paddingRight: "8px",
        },
      },
      "& span": {
        fontSize: "18px",
        fontWeight: "normal",
      },
    },

    searchInput: {
      display: "flex",
      justifyContent: "center",
      marginBottom: " 20px",
    },

    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        marginTop: "80px",
      },
    },
    select: {
      width: "100%",
      backgroundColor: theme.palette.input.main,
    },
    inputStyle: {
      backgroundColor: theme.palette.input.main,
    },
    imageBox: {
      width: "100%",
      height: "180px",
      padding: "8px",
      "& img": {
        height: "100%",
      },
    },
    thStyle: {
      fontWeight: "bold",
      backgroundColor: theme.palette.gray.main,
    },
    textArea: {
      // width: "320px",
      width: "100%",
      flex: "1 1 100%",
      fontFamily: 'Roboto, "Noto Sans KR"',
      fontSize: "14px",
      lineHeight: 1.5,
      resize: "vertical",
      backgroundColor: theme.palette.input.main,
      color: theme.palette.text.primary,
    },
    checkbox: {
      backgroundColor: theme.palette.input.main,
    },
  })
);

// type fieldCheckType = {
//   name: string;
//   processName: string;
//   itemName: string;
//   specName: string;
//   photoFile1: string;
//   photoFile2: string;
//   photoName1: string;
//   photoName2: string;
//   notice: string;
//   improve: string;
//   regulation: string;
// };

const ModifyFieldCheck = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {myProject, fieldCheck, selectContainer} = useSelector(
    (state: RootState) => state.myProject
  );
  // note SmokingScully 추가
  const {userToken} = useSelector((state: RootState) => state.auth);

  const [imgSrc1, setImgSrc1] = useState("");
  const [imgSrc2, setImgSrc2] = useState("");
  const [fileName1, setFileName1] = useState("");
  const [fileName2, setFileName2] = useState("");
  const [isNotPrint, setIsNotPrint] = useState(false);

  const thisContainer = IPUtility.getContainerByUID(myProject, selectContainer);

  const [noticeKey, setNoticeKey] = useState(IPUtility.generateUUID());
  const [improveKey, setImproveKey] = useState(IPUtility.generateUUID());
  const [regulationKey, setRegulationKey] = useState(IPUtility.generateUUID());

  // note : End of Note

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: {errors, isValid},
  } = useForm<IPFieldCheck>();
  // note SmokingScully 추가

  useEffect(() => {}, []);

  useEffect(() => {
    reset({...fieldCheck});
    IPUtility.log(fieldCheck);
    setIsNotPrint(fieldCheck.isNotPrint);
    // file1
    if (fieldCheck.photoFile1Base64 && fieldCheck.photoFile1Base64.length > 0) {
      setImgSrc1(fieldCheck.photoFile1Base64);
    } else if (fieldCheck.photoFile1 && fieldCheck.photoFile1.length > 0) {
      setImgSrc1("/uploads/inspect/checkImages/" + fieldCheck.photoFile1);
    } else setImgSrc1("");
    setFileName1(fieldCheck.photoFile1);

    // file2
    if (fieldCheck.photoFile2Base64 && fieldCheck.photoFile2Base64.length > 0) {
      setImgSrc2(fieldCheck.photoFile2Base64);
    } else if (fieldCheck.photoFile2 && fieldCheck.photoFile2.length > 0) {
      setImgSrc2("/uploads/inspect/checkImages/" + fieldCheck.photoFile2);
    } else setImgSrc2("");
    setFileName2(fieldCheck.photoFile2);
  }, [fieldCheck]);

  // note ImageLoaded - 2022-02-05 추가
  const image1Loaded = (e: React.ChangeEvent<HTMLInputElement>) => {
    IPUtility.imageLoadedHandler(e, setImgSrc1, setFileName1, 640, 480);
  };

  const image2Loaded = (e: React.ChangeEvent<HTMLInputElement>) => {
    IPUtility.imageLoadedHandler(e, setImgSrc2, setFileName2, 640, 480);
  };

  const onSubmit = (data: IPFieldCheck) => {
    const newData = {
      ...data,
      photoFile1: fileName1,
      photoFile2: fileName2,
      photoFile1Base64: imgSrc1,
      photoFile2Base64: imgSrc2,
    };
    dispatch(
      updateFieldCheck({
        userToken,
        item: newData,
        successHandler: () => {
          dispatch(getCheckList({userToken, id: newData.itemUID, pid: myProject.uid}));
        },
      })
    );
    dispatch(getCheckList({userToken, id: fieldCheck.itemUID, pid: myProject.uid}));
    dispatch(checkListSwitchAction(0));
    if (isValid) {
      dispatch(
        toastPopupOpenAction({
          contents: "업데이트 되었습니다.",
          severity: "success",
        })
      );
    }
  };

  return (
    <TableContainer component={Paper} className={classes.paper}>
      <Box
        className={classes.modalTitle}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h5" component="h5">
          <EditIcon />
          첨부목록 수정
        </Typography>
        <IconButton onClick={() => dispatch(checkListCloseAction())} aria-label="close">
          <CloseIcon style={{color: "white", fontWeight: "bold"}} />
        </IconButton>
      </Box>
      <Box p="16px">
        <Table className={classes.table} aria-label="simple table">
          <TableBody>
            <StyledTableRow>
              <TableCell className={classes.thStyle} width="200px">
                <p>공장명</p>
              </TableCell>
              <TableCell width="540px">{myProject.factoryName}</TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle} width="200px">
                <p>공정명</p>
              </TableCell>
              <TableCell width="540px">
                <Controller
                  name="processName"
                  control={control}
                  defaultValue={fieldCheck.processName}
                  render={({field}) => (
                    <Select {...field} variant="outlined" margin="dense" className={classes.select}>
                      {myProject.processNamesSerial.split(",").map((x) => {
                        return <MenuItem value={x.trim()}>{x.trim()}</MenuItem>;
                      })}
                    </Select>
                    // <TextField
                    //   {...field}
                    //   className={classes.inputStyle}
                    //   fullWidth
                    //   variant="outlined"
                    //   margin="dense"
                    //   error={errors.processName ? true : false}
                    // />
                  )}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.processName?.message}
                </Typography>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>항목</p>
              </TableCell>
              <TableCell>
                <Controller
                  name="itemName"
                  control={control}
                  defaultValue={fieldCheck.itemName}
                  render={({field}) => (
                    <TextField
                      {...field}
                      className={classes.inputStyle}
                      required
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      error={errors.itemName ? true : false}
                    />
                  )}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.itemName?.message}
                </Typography>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>위치(설비)명</p>
              </TableCell>
              <TableCell>
                <Controller
                  name="specName"
                  control={control}
                  defaultValue={fieldCheck.specName}
                  render={({field}) => (
                    <TextField
                      {...field}
                      className={classes.inputStyle}
                      required
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      error={errors.specName ? true : false}
                    />
                  )}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.specName?.message}
                </Typography>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell colSpan={2}>
                <div>
                  <div className={classes.imageBox}>
                    <img src={imgSrc1} alt="" />
                  </div>
                  <input
                    accept="image/*"
                    capture="camera"
                    onChange={image1Loaded}
                    style={{display: "none"}}
                    id="icon-button-photoImage1"
                    type="file"
                  />
                  <label htmlFor="icon-button-photoImage1">
                    <IconButton color="primary" aria-label="upload picture1" component="span">
                      <BackupIcon />
                    </IconButton>
                  </label>
                  <span>{fileName1}</span>
                </div>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>사진 1 </p>
              </TableCell>
              <TableCell>
                <Controller
                  name="photoName1"
                  control={control}
                  defaultValue={fieldCheck.photoName1}
                  render={({field}) => (
                    <TextField
                      {...field}
                      className={classes.inputStyle}
                      required
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      error={errors.photoName1 ? true : false}
                    />
                  )}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.photoName1?.message}
                </Typography>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell colSpan={2}>
                <div>
                  <div className={classes.imageBox}>
                    <img src={imgSrc2} alt="" />
                  </div>
                  <input
                    accept="image/*"
                    capture="camera"
                    onChange={image2Loaded}
                    style={{display: "none"}}
                    id="icon-button-photoImage2"
                    type="file"
                  />
                  <label htmlFor="icon-button-photoImage2">
                    <IconButton color="primary" aria-label="upload picture2" component="span">
                      <BackupIcon />
                    </IconButton>
                  </label>
                  <span>{fileName2}</span>
                </div>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>사진 2 </p>
              </TableCell>
              <TableCell>
                <Controller
                  name="photoName2"
                  control={control}
                  defaultValue={fieldCheck.photoName2}
                  render={({field}) => (
                    <TextField
                      {...field}
                      className={classes.inputStyle}
                      required
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      error={errors.photoName2 ? true : false}
                    />
                  )}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.photoName2?.message}
                </Typography>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>지적사항</p>
                <Button
                  onClick={() => {
                    dispatch(
                      altFieldCheckImproveAction({
                        type: 0,
                        text: IPUtility.getString(),
                        handler: setNoticeKey(IPUtility.generateUUID()),
                      })
                    );
                  }}
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={<FileCopyIcon />}
                ></Button>
              </TableCell>
              <TableCell colSpan={3}>
                <textarea
                  {...register("notice")}
                  key={noticeKey}
                  rows={3}
                  className={classes.textArea}
                  defaultValue={fieldCheck.notice}
                  onChange={(e) => setValue("notice", e.target.value)}
                />
                {/* <Controller
                  name="notice"
                  control={control}
                  defaultValue={fieldCheck.notice}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      key={noticeKey}
                      className={classes.inputStyle}
                      multiline
                      rows={3}
                      required
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      style={{ resize: "vertical" }}
                      error={errors.notice ? true : false}
                    />
                  )}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.notice?.message}
                </Typography> */}
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>개선대책</p>
                <Button
                  onClick={() => {
                    dispatch(
                      altFieldCheckImproveAction({
                        type: 1,
                        text: IPUtility.getString(),
                        handler: setImproveKey(IPUtility.generateUUID()),
                      })
                    );
                  }}
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={<FileCopyIcon />}
                ></Button>
              </TableCell>
              <TableCell colSpan={3}>
                <textarea
                  {...register("improve")}
                  key={improveKey}
                  rows={3}
                  className={classes.textArea}
                  defaultValue={fieldCheck.improve}
                  onChange={(e) => setValue("improve", e.target.value)}
                />
                {/* <Controller
                  name="improve"
                  control={control}
                  defaultValue={fieldCheck.improve}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      key={improveKey}
                      className={classes.inputStyle}
                      multiline
                      rows={3}
                      required
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      error={errors.improve ? true : false}
                    />
                  )}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.improve?.message}
                </Typography> */}
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>관련법규</p>
                <Button
                  onClick={() => {
                    dispatch(
                      altFieldCheckImproveAction({
                        type: 2,
                        text: IPUtility.getString(),
                        handler: setRegulationKey(IPUtility.generateUUID()),
                      })
                    );
                  }}
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={<FileCopyIcon />}
                ></Button>
              </TableCell>
              <TableCell colSpan={3}>
                <textarea
                  {...register("regulation")}
                  key={regulationKey}
                  rows={3}
                  className={classes.textArea}
                  defaultValue={fieldCheck.regulation}
                  onChange={(e) => setValue("regulation", e.target.value)}
                />
                {/* <Controller
                  name="regulation"
                  control={control}
                  defaultValue={fieldCheck.regulation}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      key={regulationKey}
                      className={classes.inputStyle}
                      multiline
                      rows={3}
                      required
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      style={{ resize: "vertical" }}
                      error={errors.regulation ? true : false}
                    />
                  )}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.regulation?.message}
                </Typography> */}
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>출력제외</p>
              </TableCell>
              <TableCell colSpan={3}>
                <Box className={classes.checkbox}>
                  <Checkbox
                    checked={isNotPrint}
                    onChange={(e) => {
                      setIsNotPrint(e.target.checked);
                      setValue<"isNotPrint">("isNotPrint", e.target.checked);
                    }}
                  />
                </Box>
                {/* <Controller
                  name="isNotPrint"
                  control={control}
                  defaultValue={fieldCheck.isNotPrint}
                  render={({ field }) => <Checkbox {...field} defaultChecked={fieldCheck.isNotPrint} onChange={(e) => { setValue<"isNotPrint">("isNotPrint", e.target.checked) }}  />}
                /> */}
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>분류</p>
              </TableCell>
              <TableCell colSpan={3}>
                <Controller
                  name="itemUID"
                  control={control}
                  defaultValue={fieldCheck.itemUID}
                  render={({field}) => (
                    <Select {...field} variant="outlined" margin="dense" className={classes.select}>
                      {thisContainer.items.map((item, index) => (
                        <MenuItem key={item.uid} value={item.uid}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                    // <Select
                    //   {...field}
                    //   className={classes.inputStyle}
                    //   required
                    //   fullWidth
                    //   variant="outlined"
                    //   margin="dense"
                    //   error={errors.itemUID ? true : false}
                    // />
                  )}
                />
              </TableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </Box>
      <Box display="flex" justifyContent="space-between" mx="16px">
        <Box>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<ListIcon />}
            onClick={() => {
              dispatch(checkListSwitchAction(0));
            }}
          >
            리스트
          </Button>
          <Button
            style={{marginLeft: "16px"}}
            variant="contained"
            color="primary"
            startIcon={<EditIcon />}
            onClick={handleSubmit(onSubmit)}
          >
            수정
          </Button>
        </Box>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              dispatch(fieldCheckSearchListOpenAction());
            }}
          >
            검색
          </Button>
        </Box>
      </Box>
      {/* <Box display="flex" justifyContent="flex-start" ml="16px">
        <Button
          variant="contained"
          color="secondary"
          startIcon={<ListIcon />}
          onClick={() => {
            dispatch(checkListSwitchAction(0));
          }}
        >
          리스트
        </Button>
        <Button
          style={{ marginLeft: "16px" }}
          variant="contained"
          color="primary"
          startIcon={<EditIcon />}
          onClick={handleSubmit(onSubmit)}
        >
          수정
        </Button>
      </Box> */}
    </TableContainer>
  );
};

export default ModifyFieldCheck;
